import { render, staticRenderFns } from "./privacyRev_list.vue?vue&type=template&id=ce19a03a&scoped=true&"
import script from "./privacyRev_list.vue?vue&type=script&lang=js&"
export * from "./privacyRev_list.vue?vue&type=script&lang=js&"
import style0 from "./privacyRev_list.vue?vue&type=style&index=0&id=ce19a03a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce19a03a",
  null
  
)

export default component.exports